<template>
  <div class="tools-mobile">
    <Tool v-for="tool in tools" :key="tool.route.name" v-bind="tool"/>
  </div>
</template>

<script>
import Tool from './Tool.vue'

export default {
  name: 'HomeTools',
  data () {
    return {
      routes: function (groupName) {
        return this.productRoutes.filter(route => route.name !== this.$route.name && route.groups && route.groups[groupName]).sort((a, b) => a.groups[groupName] - b.groups[groupName])
      }
    }
  },
  computed: {
    productRoutes: app => app.$router.options.routes.find(route => route.name === 'Product').children,
    productRoutesHash: app => app.productRoutes.reduce((routes, route) => ({ ...routes, [route.name]: route }), {}),
    tools: app => ([
      {
        route: app.productRoutesHash['Fundamentals'],
        big: true
      },
      {
        route: app.productRoutesHash['Drive'],
        middle: true
      },
      {
        route: app.productRoutesHash['PolicyManualWizard'],
        small: true
      },
      {
        route: app.productRoutesHash['Surveys'],
        small: true
      },
      {
        route: app.productRoutesHash['Training'],
        middle: true
      },
      {
        route: app.productRoutesHash['JobDescriptionGenerator'],
        small: true
      },
      {
        route: app.productRoutesHash['LiveHrAdvice'],
        small: true
      },
      {
        route: app.productRoutesHash['TimeAttendance'],
        tag: app.$t('products.tools.coming-soon'),
        smallH: true
      },
      {
        route: app.productRoutesHash['Complete'],
        middle: true
      }
    ])
  },
  components: { Tool }
}
</script>

<style lang="sass" scoped>
.tools-mobile
  display: grid
  grid-template-columns: repeat(2, minmax(0, 1fr))
  grid-gap: $spacer
  max-width: 540px
  margin: auto
</style>



// WEBPACK FOOTER //
// src/components/ui/HomeTools.vue